<template>
  <div class="category__menu" @mouseleave="updateCurrentCategory">
    <div class="category__menu-content">
      <LangRouterLink
        :to="{ ...route }"
        :class="['category__menu-tagline', color(category.color)]"
        :title="category.tagline"
      >
        <Image :source="category.icon" />
        <p>{{ category.tagline }}</p>
      </LangRouterLink>
      <div class="category__menu-section-group">
        <LangRouterLink
          :to="{ ...route, hash: `#${link.section}` }"
          v-for="(link, linkKey) in category.menu"
          :key="linkKey"
          class="category__menu-section"
          :title="link.title"
        >
          <span class="category__menu-section-title">
            <span>{{ link.title }}</span>
            <Icon id="arrow" />
          </span>
          <span>{{ link.description }}</span>
        </LangRouterLink>
      </div>
    </div>
    <Image :source="category.image" class="category__menu-image" />
  </div>
</template>

<script>
import { Icon, Image, LangRouterLink } from '@/components/global'
import { color } from '@/helpers/color.js'

export default {
  name: 'CategoryMenu',
  props: {
    category: {
      type: Object,
      required: true,
    },
  },
  components: { Icon, Image, LangRouterLink },
  computed: {
    route() {
      return { name: 'category', params: { slug: this.category.slug } }
    },
  },
  methods: {
    color,
    updateCurrentCategory() {
      this.$store.dispatch('updateActiveCategory', null)
    },
  },
}
</script>
